webpackJsonp([21722385132462],{

/***/ 40:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IssueNavigation = function (_React$Component) {
	  _inherits(IssueNavigation, _React$Component);
	
	  function IssueNavigation(props) {
	    _classCallCheck(this, IssueNavigation);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  IssueNavigation.prototype.render = function render() {
	    var _this2 = this;
	
	    var issue_navigation = [{ name: 'moving_image',
	      title: 'moving image' }, { name: 'still_image',
	      title: 'still image' }, { name: 'textz',
	      title: 'textz' }, { name: 'soundz',
	      title: 'soundz' }].map(function (section_metadata, index) {
	      return _this2.props.issue_data[section_metadata.name + '_count'] > 0 ? _react2.default.createElement(
	        'li',
	        { key: index },
	        _react2.default.createElement(
	          'a',
	          { href: '/issue/' + _this2.props.issue_data.issue_date + '/' + section_metadata.name + '/1' },
	          section_metadata.title
	        )
	      ) : null;
	    });
	
	    return _react2.default.createElement(
	      'ul',
	      null,
	      issue_navigation.map(function (item) {
	        return item;
	      })
	    );
	  };
	
	  return IssueNavigation;
	}(_react2.default.Component);
	
	exports.default = IssueNavigation;
	module.exports = exports['default'];

/***/ }),

/***/ 204:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _issue_navigation = __webpack_require__(40);
	
	var _issue_navigation2 = _interopRequireDefault(_issue_navigation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Artwork = function (_React$Component) {
	  _inherits(Artwork, _React$Component);
	
	  function Artwork() {
	    _classCallCheck(this, Artwork);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this));
	  }
	
	  Artwork.prototype.navigateToArtwork = function navigateToArtwork(event) {
	    this.props.history.push('/issue/' + artwork_data.issue_date + '/' + artwork_data.media_type + '/' + event.target.value);
	  };
	
	  Artwork.prototype.render = function render() {
	    var artwork_data = this.props.data.contributionsJson;
	    var section_artworks = Array.from({ length: artwork_data[artwork_data.media_type + '_count'] }, function (x, i) {
	      return i;
	    });
	    var section_base_path = '/issue/' + artwork_data.issue_date + '/' + artwork_data.media_type;
	    var prev_link = artwork_data.position_in_section > 1 ? _react2.default.createElement(
	      'a',
	      { href: section_base_path + '/' + (artwork_data.position_in_section - 1) },
	      'prev'
	    ) : _react2.default.createElement(
	      'span',
	      { className: 'inactive' },
	      'prev'
	    );
	    var next_link = artwork_data.position_in_section < artwork_data[artwork_data.media_type + '_count'] ? _react2.default.createElement(
	      'a',
	      { href: section_base_path + '/' + (artwork_data.position_in_section + 1) },
	      'next'
	    ) : _react2.default.createElement(
	      'span',
	      { className: 'inactive' },
	      'next'
	    );
	
	    /**
	     * Source data contains only two types of media URIs: local (without
	     * leading '/') and remote (just two HTTP URIs). For local, i.e. everything
	     * that starts with 'media' (e.g. 'media/2008/August/still_image/06a.jpg'),
	     * we prepend a leading '/' to make src attributes work properly.
	     */
	    var artwork_media_uri = artwork_data.media_uri.slice(0, 5) === 'media' ? '/' + artwork_data.media_uri : artwork_data.media_uri;
	
	    /**
	     * Markup of player depends on content type: <img> for still images and textz
	     * (which are images of text), <video> and <audio> for soundz and moving
	     * images, respectively.
	     */
	    var artwork_players = {
	      'still_image': _react2.default.createElement('img', { src: '' + artwork_media_uri }),
	      'textz': _react2.default.createElement('img', { src: '' + artwork_media_uri }),
	      'moving_image': _react2.default.createElement('video', { src: '' + artwork_media_uri, controls: true }),
	      'soundz': _react2.default.createElement('audio', { src: '' + artwork_media_uri, controls: true })
	    };
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'issue' },
	      _react2.default.createElement(
	        'div',
	        { className: 'sideBarLeft' },
	        _react2.default.createElement(
	          'div',
	          { className: 'cover' },
	          _react2.default.createElement(
	            'a',
	            { href: '/issue/' + artwork_data.issue_date },
	            'cover'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'sections' },
	          _react2.default.createElement(_issue_navigation2.default, { issue_data: artwork_data })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'impressum' },
	          _react2.default.createElement(
	            'ul',
	            null,
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'a',
	                { href: '/about/' },
	                'about'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'a',
	                { href: '/editorial/' },
	                'editorial'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'a',
	                { href: '/contact/' },
	                'contact'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'archive' },
	          _react2.default.createElement(
	            'a',
	            { href: '/archive/' },
	            'archive'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'artwork' },
	        artwork_players[artwork_data.media_type]
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'nav-and-metadata' },
	        _react2.default.createElement(
	          'h3',
	          { className: 'nav' },
	          'Navigate ',
	          artwork_data.media_type.replace('_', ' ')
	        ),
	        _react2.default.createElement(
	          'ul',
	          null,
	          _react2.default.createElement(
	            'li',
	            null,
	            prev_link
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            next_link
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'select',
	              { onChange: this.navigateToArtwork, name: 'fastSelect', id: 'fastSelect', value: artwork_data.position_in_section },
	              section_artworks.map(function (item, index) {
	                return _react2.default.createElement(
	                  'option',
	                  { key: index + 1, value: '/issue/' + artwork_data.issue_date + '/' + artwork_data.media_type + '/' + (index + 1) },
	                  index + 1
	                );
	              })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'h3',
	          { className: 'meta' },
	          'Artwork Information'
	        ),
	        _react2.default.createElement(
	          'dl',
	          { className: 'metadata' },
	          _react2.default.createElement(
	            'dt',
	            null,
	            'Theme'
	          ),
	          _react2.default.createElement(
	            'dd',
	            null,
	            artwork_data.thema
	          ),
	          _react2.default.createElement(
	            'dt',
	            null,
	            'Date'
	          ),
	          _react2.default.createElement(
	            'dd',
	            null,
	            artwork_data.issue_month,
	            ' ',
	            artwork_data.issue_year
	          ),
	          _react2.default.createElement(
	            'dt',
	            null,
	            'Artwork'
	          ),
	          _react2.default.createElement(
	            'dd',
	            null,
	            artwork_data.name
	          ),
	          _react2.default.createElement(
	            'dt',
	            null,
	            'Artist'
	          ),
	          _react2.default.createElement(
	            'dd',
	            null,
	            artwork_data.artist
	          ),
	          _react2.default.createElement(
	            'dt',
	            null,
	            'Location'
	          ),
	          _react2.default.createElement(
	            'dd',
	            null,
	            artwork_data.location
	          ),
	          _react2.default.createElement(
	            'dt',
	            { className: 'hack' },
	            _react2.default.createElement(
	              'a',
	              { href: 'mailto:' + artwork_data.email },
	              'email'
	            )
	          ),
	          _react2.default.createElement(
	            'dd',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: artwork_data.www_url },
	              'website'
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return Artwork;
	}(_react2.default.Component);
	
	exports.default = Artwork;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-artwork-js-b38b3559e63b207c8dec.js